import React from "react";

function Forecast({ data, city }) {
  const images = require.context("../weather-icons", true);

  return (
    <div
      dir="rtl"
      className="h-[15.5rem]  text-white flex overflow-x-scroll scrollbar-thin scrollbar-track-blue-100 scrollbar-thumb-blue-600 grad p-5 font-bold rounded-lg lg:gap-5 "
    >
      {data ? (
        data.list?.map((item, id) => (
          <div
            key={id}
            className="w-[7rem] min-w-[7rem] bg-gray-200/10 p-2 rounded text-center"
          >
            <div className="flex flex-col  font-bold">
              <div className="italic">
                {new Date(item.dt_txt).toLocaleString("ar-SA", {
                  weekday: "long",
                })}
              </div>
              <div dir="ltr " className="">
                {new Date(item.dt_txt).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            </div>
            <img
              // src={`http://openweathermap.org/img/wn/${item?.weather[0].icon}.png`}
              src={images(`./${item?.weather[0].icon}.png`)}
              alt="weather"
              className="mx-auto w-16 h-16"
            />
            <div className="">
              {Math.round(item.main.temp)}
              °C
            </div>
            <div className="italic">{item.weather[0].description}</div>
          </div>
        ))
      ) : (
        <div className="flex items-center  gap-4">
          {[...Array(10).keys()].map((e, index) => (
            <div key={index} className="bg-[#dddddd] animate-pulse w-[8rem] rounded-lg h-[11rem] mx-auto "></div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Forecast;
